import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button-chat-box',
  templateUrl: './button-chat-box.component.html',
  styleUrls: ['./button-chat-box.component.scss']
})
export class ButtonChatBoxComponent {
  showChatPopup = false;
  @Input() messages = [];
  @Input() hasNewMessage = false;
  @Output() sendMessage = new EventEmitter<string>();
  @Output() markMessageAsRead = new EventEmitter<boolean>();

  public onSendMessage(text: string) {
    this.sendMessage.emit(text);
  }

  public onClickChatButton() {
    this.showChatPopup = !this.showChatPopup;
    if (this.showChatPopup) {
      this.hasNewMessage = false;
      this.markMessageAsRead.emit(true);
    }
  }
}
